(() => {
  'use strict';
  if (window.KkupoCartDrawerReady) return;
  window.KkupoCartDrawerReady = true;
  document.documentElement.classList.add('cart-drawer-js');

  const cartUrl = () => window.AtelierTheme?.cartUrl || '/cart';
  const changeUrl = () => `${window.Shopify?.routes?.root || '/'}cart/change.js`;

  async function changeLine(line, quantity) {
    const dialog = line.closest('[data-cart-dialog]');
    if (!dialog || dialog.dataset.updating) return;
    dialog.dataset.updating = 'true';
    dialog.setAttribute('aria-busy', 'true');
    const message = dialog.querySelector('[data-cart-error]');
    if (message) message.hidden = true;
    try {
      const response = await fetch(changeUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          id: line.dataset.cartLineKey,
          quantity,
          sections: ['cart-drawer'],
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not update your cart.');
      const markup = data.sections?.['cart-drawer'];
      if (!markup) { window.location.assign(cartUrl()); return; }
      const updated = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-dialog]');
      if (!updated) { window.location.assign(cartUrl()); return; }
      dialog.close();
      dialog.replaceWith(updated);
      updated.showModal();
      document.querySelectorAll('[data-cart-count]').forEach(node => {
        if (node !== updated) node.textContent = updated.dataset.cartCount || '0';
      });
      const matching = [...updated.querySelectorAll('[data-cart-line-key]')]
        .find(node => node.dataset.cartLineKey === line.dataset.cartLineKey);
      (matching?.querySelector('[data-cart-quantity]') || updated.querySelector('.cart-drawer__close'))?.focus({preventScroll:true});
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: data}}));
    } catch (error) {
      if (message) {
        message.textContent = error.message || 'Could not update your cart.';
        message.hidden = false;
      }
    } finally {
      delete dialog.dataset.updating;
      dialog.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const step = event.target.closest('[data-cart-step]');
    const remove = event.target.closest('[data-cart-remove]');
    const action = step || remove;
    const line = action?.closest('[data-cart-line-key]');
    if (!line || !line.closest('[data-cart-dialog]')) return;
    const input = line.querySelector('[data-cart-quantity]');
    if (!input) return;
    event.preventDefault();
    const count = remove ? 0 : Math.max(0, Number(input.value) + Number(step.dataset.cartStep));
    if (!Number.isInteger(count) || count === Number(input.defaultValue)) return;
    changeLine(line, count);
  });

  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-cart-dialog] [data-cart-quantity]')) return;
    const quantity = Number(event.target.value);
    if (!Number.isInteger(quantity) || quantity < 0) {
      event.target.value = event.target.defaultValue;
      return;
    }
    if (quantity !== Number(event.target.defaultValue)) changeLine(event.target.closest('[data-cart-line-key]'), quantity);
  });
})();
